
export class TimeHelper {

    public static displayTime(val): string{
        if (!val) return "";

        const day  = Math.floor(val / 60/ 60 / 24);
        const hour = Math.floor((val / 60 / 60) % 24);
        const min = Math.floor((val / 60) % 60);
        const sec = Math.floor(val % 60);

        let display = "";
        display = ("0" + sec).slice(-2) + display;
        if(!!min)display = ("0" + min).slice(-2) + ":" + display;
        if(!!hour)display = ("0" + hour).slice(-2) + ":" + display;
        if(!!day)display = (""+day).slice(-2) + " " + TimeHelper.getPlural(day) + " " + display;

        return display
    };

    private static getPlural(len) {
        if (len == 0 || len > 20 && len % 10 == 0) return 'дней';
        if (len == 1 || len > 20 && len % 10 == 1) return 'день';
        if (len > 1 && len < 5 || len > 20 && len % 10 > 1 && len % 10 < 5) return 'дня';
        if (len > 4 && len < 21 || len > 20 && len % 10 > 4 && len % 10 < 10) return 'дней';
        if (len > 20 && len % 10 > 1 && len % 10 < 5) return 'дня';
        return '';
    }
}